import { Component, HostListener, Inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { ProductoList } from '@app/entidades/operacion.model';
import { OperacionService } from '@app/servicios/operacion/operacion.service';
import { StorageService } from '@app/servicios/storage/storage.service';
import { TokenService } from '@app/auth/auth/token.service';
import { AdminService } from '@app/servicios/admin/admin.service';
import { environment } from '@env';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
})
export class SubHeaderComponent {
  fotoUrl = environment.servImgURL + '/';
  public subscriber: Subscription;
  cart = false;

  private tiendaService = Inject(OperacionService);
  unidadesSaphirus = 0;

  public lista: ProductoList[] = [];
  public menuAbierto = false;
  modal = false;
  productos = false;
  mayorista = false;

  public breadcrumb = false;
  breadcrumbdata = this.tiendaService.breadcrumbdata;

  mobile: boolean = false;
  web: boolean = false;
  total: number;
  loggedIn: boolean;
  subtotal: number;
  montoMay2: number = 0;

  @HostListener('window:resize', ['$event'])
  onResize() {
    const width = window.innerWidth;
    this.mobile = width < 1024;
    this.web = width >= 1024;
    if (this.web) {
      this.verificarSesion();
    }
  }

  constructor(
    private tokenService: TokenService,
    private router: Router,
    private storageService: StorageService,
    private adminService: AdminService
  ) {}

  ngOnInit() {
    this.onResize();
    this.adminService.consultarMonto();

    this.subscriber = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.verificarSesion();
      });

    this.montoMay2 = this.adminService.current_monto;
  }

  public verificarSesion() {
    if (this.tokenService.isLoggedIn()) {
      if (this.tokenService.notExpired) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    } else {
      this.loggedIn = false;
    }
  }

  filtroCarrito: string = '';
  listaFiltrada: ProductoList[] = [];

  get totalItems(): number {
    const list = this.storageService.getItem('lp');
    if (!list || !Array.isArray(list)) return 0;
    return list.reduce((acc: number, item: any) => acc + (+(item.cantidad ?? 1)), 0);
  }

  /*--- CARRITO ---*/
  consultarProductos() {
    this.lista = this.storageService.getItem('lp') || [];

    if (!this.lista || this.lista.length === 0) {
      this.total = 0;
      this.subtotal = 0;
      this.listaFiltrada = [];
      return;
    }

    this.checkearSaphirus();

    if(this.unidadesSaphirus >=600){
      this.precioSaphirus();
    }else{
      this.calcularTotal();
    }

    this.filtrarCarrito(this.filtroCarrito);
  }

  calcularTotal() {
    if (!this.lista || this.lista.length === 0) {
      this.total = 0;
      this.subtotal = 0;
      return;
    }

    if (this.loggedIn) {
      let subtotal = 0;
      this.lista.forEach((producto) => {
        subtotal += (+(producto.precio?.may1 ?? 0)) * (+(producto.cantidad ?? 0));
      });

      this.subtotal = subtotal;

      const montoMay2 = this.adminService.current_monto || 200000;
      if (subtotal >= montoMay2) {
        let total = 0;
        this.lista.forEach((producto) => {
          total += (+(producto.precio?.may2 ?? producto.precio?.may1 ?? 0)) * (+(producto.cantidad ?? 0));
        });
        this.total = total;
      } else {
        this.total = subtotal;
      }
    }

    if (!this.loggedIn) {
      let total = 0;
      this.lista.forEach((producto) => {
        total += (+(producto.precio?.publico ?? 0)) * (+(producto.cantidad ?? 0));
      });

      this.total = total;
      this.subtotal = total;
    }
  }

  sumar(id: string) {
    this.lista.forEach((producto) => {
      if (producto.id === id) {
        if(producto.stock ==producto.cantidad){
          return;
        }
        producto.cantidad++;
      }
    });
    this.storageService.setItem('lp', this.lista);
    this.checkearSaphirus();

    if(this.unidadesSaphirus >=600){
      this.precioSaphirus();
    }else{
      this.calcularTotal();
    }
    this.filtrarCarrito(this.filtroCarrito);
  }

  restar(id: string) {
    this.lista.forEach((producto) => {
      if (producto.id === id) {
        if (producto.cantidad > 1) {
          producto.cantidad--;
        }
      }
    });
    this.storageService.setItem('lp', this.lista);
    this.checkearSaphirus();

    if(this.unidadesSaphirus >=600){
      this.precioSaphirus();
    }else{
      this.calcularTotal();
    }
    this.filtrarCarrito(this.filtroCarrito);
  }

  public eliminar(id: any) {
    let filtrados = this.lista.filter((p) => p.id != id);

    this.lista = filtrados;

    this.checkearSaphirus();

    if(this.unidadesSaphirus >=600){
      this.precioSaphirus();
    }else{
      this.calcularTotal();
    }

    this.storageService.setItem('lp', this.lista);
    this.filtrarCarrito(this.filtroCarrito);
  }

  vaciarCarrito(): void {
    this.lista = [];
    this.listaFiltrada = [];
    this.storageService.removeItem('lp');
    this.total = 0;
    this.subtotal = 0;
    this.unidadesSaphirus = 0;
  }

  filtrarCarrito(term: string = ''): void {
    this.filtroCarrito = term;
    if (!this.lista) {
      this.listaFiltrada = [];
      return;
    }
    if (!term || !term.trim()) {
      this.listaFiltrada = [...this.lista];
      return;
    }
    const normalizado = term.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    this.listaFiltrada = this.lista.filter((p) => {
      const nombreNorm = (p.nombre || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const marcaNorm = (p.marca || p.tipo || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const descNorm = (p.descripcion || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return nombreNorm.includes(normalizado) || marcaNorm.includes(normalizado) || descNorm.includes(normalizado);
    });
  }

  limpiarFiltroCarrito(): void {
    this.filtroCarrito = '';
    this.listaFiltrada = [...(this.lista || [])];
  }

  get montoMay2Threshold(): number {
    return this.adminService.current_monto || environment.montoMay2 || 200000;
  }

  get aplicaMay2(): boolean {
    if (!this.loggedIn) return false;
    return (this.subtotal ?? 0) >= this.montoMay2Threshold;
  }

  getPrecioUnitario(prod: ProductoList): number {
    if (!prod || !prod.precio) return 0;
    if (prod.tipo === 'SAPHIRUS' && this.unidadesSaphirus >= 600) {
      return Number(prod.precio.may3 ?? 0);
    }
    if (this.loggedIn) {
      if (this.aplicaMay2) {
        return Number(prod.precio.may2 ?? prod.precio.may1 ?? 0);
      }
      return Number(prod.precio.may1 ?? 0);
    }
    return Number(prod.precio.publico ?? 0);
  }

  getPrecioTotal(prod: ProductoList): number {
    return this.getPrecioUnitario(prod) * (Number(prod.cantidad) || 0);
  }


  checkearSaphirus() {
    this.unidadesSaphirus= 0;
    this.lista.forEach((pp) => {
      if (pp.tipo === 'SAPHIRUS') {
        this.unidadesSaphirus =
          parseInt(this.unidadesSaphirus.toString()) +
          parseInt(pp.cantidad.toString());
      }
    });
  }


  precioSaphirus() {

    if (this.loggedIn) {
      let subtotal = 0;
      this.lista.forEach((producto) => {
        if (producto.tipo === 'SAPHIRUS') {
          subtotal += producto.precio.may3 * producto.cantidad;
        }else{
          subtotal += producto.precio.may1 * producto.cantidad;
        }
      });

      this.subtotal = subtotal;

      if (subtotal >= this.adminService.current_monto) {
        let total = 0;
        this.lista.forEach((producto) => {
          if (producto.tipo === 'SAPHIRUS') {
            total += producto.precio.may3 * producto.cantidad;
          }else{
            total += producto.precio.may2 * producto.cantidad;
          }
        });
        this.total = total;
      } else {
        this.total = subtotal;
      }
    }

    if (!this.loggedIn) {
      let total = 0;
      this.lista.forEach((producto) => {
        if (producto.tipo === 'SAPHIRUS') {
          total += producto.precio.may3 * producto.cantidad;
        }else{
          total += producto.precio.publico * producto.cantidad;
        }
      });

      this.total = total;
      this.subtotal = total;
    }

  }
}
